import type {
  ChatsChannelBase,
  ChatsChannelSetting
} from '../../../constants/types';
import { ChatsChannelType } from '../../../constants/types';
import { getChatIcon } from '../../helpers';

export const getLineSettings = ({
  lineAccountId
}: Partial<ChatsChannelBase>) => {
  if (!lineAccountId) return null;

  const { url, fallbackUrl } = (() => {
    const isQRLink = lineAccountId.startsWith('https://line.me/ti/p/');
    if (isQRLink) {
      return { url: lineAccountId };
    }

    const accountIdWithTag = `@${lineAccountId.replace(/^@/, '')}`;
    const encodedAccountId = encodeURIComponent(accountIdWithTag);

    return {
      url: `https://line.me/R/ti/p/${encodedAccountId}`,
      fallbackUrl: `https://line.me/R/ti/p/${lineAccountId}`
    };
  })();

  return {
    provider: ChatsChannelType.line,
    link: { url, fallbackUrl },
    title: 'Line',
    icon: getChatIcon(ChatsChannelType.line),
    color: 'rgb(7, 181, 59)'
  } as ChatsChannelSetting;
};
